import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { listeClients } from "../actions/clientsActions";
import { saveVariableGlo } from "../actions/chariotActions";
import "../RechRepresentant.css";

const RechRepresentant = () => {
  const [search, setSearch] = useState("");
  const [cliTab, setCliTab] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const params = location.state || {};

  const cListe = useSelector((state) => state.clientsListeState);
  const { clients, loading } = cListe;
  const Cl = useSelector((state) => state.client);
  const { client } = Cl;

  useEffect(() => {
    document.title =
      params.langue === "F" ? "Liste des Réprésentant" : "قائمـــة الحرفاء";

    if (!client) {
      navigate("/");
    }
  }, []);

  useEffect(() => {
    setCliTab([]);

    if (search === "") {
      dispatch(listeClients());
      if (client?.nivcli_cloud === "R" && client?.REP_GERCLI === "N") {
        clients?.forEach((cli) => {
          if (cli.cod_rep === client.cod_cli) {
            setCliTab((prev) => [...prev, cli]);
          }
        });
      } else {
        setCliTab(clients);
      }
    } else {
      clients?.forEach((cli) => {
        if (client?.nivcli_cloud === "R" && client?.REP_GERCLI === "N") {
          if (
            cli.nom_cli.toUpperCase().includes(search.toUpperCase()) &&
            cli.cod_rep === client.cod_cli
          ) {
            setCliTab((prev) => [...prev, cli]);
          }
        } else {
          if (cli.nom_cli.toUpperCase().includes(search.toUpperCase())) {
            setCliTab((prev) => [...prev, cli]);
          }
        }
      });
    }
  }, [client, search, clients]);

  const handleRepresentativeClick = (item) => {
    if (params.crit === "det") {
      dispatch(saveVariableGlo(item));
      navigate("/RepresDetail", { state: { code: item.cod_cli } });
    } else {
      navigate("/commande-graph-rep", {
        state: {
          code: item.cod_cli,
          crit: "repres",
          nom: item.nom_cli,
        },
      });
    }
  };

  return (
    <div className="rech-representant-container">
      <div className="search-container">
        <input
          type="text"
          placeholder="Chercher Client"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="search-input"
        />
      </div>

      {loading ? (
        <div className="loading-container">
          <div className="spinner"></div>
        </div>
      ) : (
        <div className="results-container">
          <div className="table-header">
            <div className="header-cell code-cell">Code Client</div>
            <div className="header-cell name-cell">Nom</div>
          </div>

          <div className="representatives-list">
            {cliTab?.map(
              (item) =>
                item?.nivcli_cloud === "R" && (
                  <div
                    key={item.cod_cli}
                    className="representative-item"
                    onClick={() => handleRepresentativeClick(item)}
                  >
                    <div className="item-cell code-cell">{item.cod_cli}</div>
                    <div className="item-cell name-cell">{item.nom_cli}</div>
                  </div>
                )
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default RechRepresentant;
